import ConstantFunctions from "../../../../utils/constants_functions";

export const CurrencyAmountRenderer = (props: any) => {
  const constantFunctions = new ConstantFunctions();

  const { value, data, colDef } = props;
  const currencyIcon = colDef.field === "baseAmount" ? data.fci : data.tci;

  return (
    <div className="flex flex-row items-center justify-start gap-[4px] h-full">
      <img src={currencyIcon} height={10} width={10} alt="currency icon" />
      <p>{constantFunctions.formatAmount(value ?? 0)}</p>
    </div>
  );
};
